import { render, staticRenderFns } from "./ChangeLanguage.vue?vue&type=template&id=10f994d6"
import script from "./ChangeLanguage.vue?vue&type=script&lang=ts"
export * from "./ChangeLanguage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports